import Decimal from "decimal.js";
import { z } from "zod";
// INR-only. INR displays with 2 decimal places (paise). Money values are
// always strings on the wire; the regex tolerates up to 3 fractional digits so
// internal arithmetic that retains extra precision still validates. When
// multi-currency support lands, switch to a per-currency precision lookup.
const MoneyValueRegex = /^-?\d+(\.\d{1,3})?$/;
export const MoneySchema = z.object({
    value: z
        .string()
        .regex(MoneyValueRegex, "Money value must be a fixed-precision decimal string with up to 3 decimal places"),
    currency: z.string().length(3),
});
export function moneyToDecimal(m) {
    return new Decimal(m.value);
}
/**
 * Convert a Decimal to wire-format Money.
 *
 * @param precision Number of fractional digits. Defaults to 2 because the app
 *   is INR-only (INR has 2 decimal places). Multi-currency work should replace
 *   the default with a per-currency lookup map.
 */
export function decimalToMoney(d, currency = "INR", precision = 2) {
    return { value: d.toFixed(precision), currency };
}
export function addMoney(a, b) {
    if (a.currency !== b.currency) {
        throw new Error(`Cannot add money with different currencies: ${a.currency} vs ${b.currency}`);
    }
    return decimalToMoney(moneyToDecimal(a).plus(moneyToDecimal(b)), a.currency);
}
//# sourceMappingURL=money.js.map